import { createSelector } from '@ngrx/store';

import { notificationFeature } from './notification.feature';
import { NotificationUnreadCounts } from './notification.model';

export const selectNotifications = notificationFeature.selectNotifications;
export const selectUnseenCount = notificationFeature.selectUnseenCount;
export const selectCommunicationCount =
  notificationFeature.selectCommunicationCount;
export const selectNeedsActionCount =
  notificationFeature.selectNeedsActionCount;
export const selectLoading = notificationFeature.selectLoading;
export const selectError = notificationFeature.selectError;
export const selectNotificationsCachedAt =
  notificationFeature.selectNotificationsCachedAt;
export const selectUnseenCountCachedAt =
  notificationFeature.selectUnseenCountCachedAt;
export const selectApplyingNotificationIds =
  notificationFeature.selectApplyingNotificationIds;

export const selectHasUnseen = createSelector(
  selectUnseenCount,
  (unseenCount) => unseenCount > 0,
);

export const selectUnreadCounts = createSelector(
  selectUnseenCount,
  selectCommunicationCount,
  selectNeedsActionCount,
  (
    unseenCount,
    communicationCount,
    needsActionCount,
  ): NotificationUnreadCounts => ({
    unseenCount,
    communicationCount,
    needsActionCount,
  }),
);
